module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-21.4f3c111c.png";